var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import LottieButton from '../components/LottieButton';
import * as React from "react";
import * as _ from "lodash";
import { styled } from "../theme/ThemeHelpers";
import { lightenColor, getColor } from '../helpers/ColorHelpers';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    height:1.4285em;\n    padding:0;\n"], ["\n    display: inline-block;\n    height:1.4285em;\n    padding:0;\n"])));
var RadioButtonContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    float:left;\n    margin-top:-0.25em;\n    margin-right:5px;\n    height:1.4285em;\n"], ["\n    float:left;\n    margin-top:-0.25em;\n    margin-right:5px;\n    height:1.4285em;\n"])));
var LabelContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    line-height:1.4285em;\n    font-weight:500;\n    //color:", ";\n    color: ", ";\n    cursor: pointer;\n    &:hover{\n        color:", ";\n    }\n"], ["\n    display: inline-block;\n    line-height:1.4285em;\n    font-weight:500;\n    //color:", ";\n    color: ", ";\n    cursor: pointer;\n    &:hover{\n        color:", ";\n    }\n"])), function (props) { return lightenColor(props, props.theme.colors.darkGrey, 50); }, function (p) { return getColor(p, p.theme.color); }, function (props) { return getColor(props, props.theme.colors.accent); });
var RadioButton = /** @class */ (function (_super) {
    __extends(RadioButton, _super);
    function RadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioButton.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, rest = __rest(_a, ["onClick"]);
        return (React.createElement(Container, { onClick: onClick },
            React.createElement(RadioButtonContainer, null,
                React.createElement(LottieButton, __assign({}, rest, { kind: "fullTransparentButton", lottie: {
                        speed: 4, url: "./images/lottiIcons/radiobutton.json",
                        behaviour: "PlayOnClickToggleDirection",
                        padding: "2px 3px 3px 2px"
                    }, size: "mini" }))),
            React.createElement(LabelContainer, null, this.props.label)));
    };
    return RadioButton;
}(React.PureComponent));
export default RadioButton;
var RadioGroup = /** @class */ (function (_super) {
    __extends(RadioGroup, _super);
    function RadioGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.setActive = function (i) {
            // console.log(i);
            var active = _this.state.active;
            active = active !== i ? i : undefined;
            _this.setState({ active: active });
        };
        _this.state = {};
        return _this;
    }
    RadioGroup.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var active = this.state.active;
        var filtered = _.isArray(props.children) ? _.filter(props.children, function (c) {
            if (c)
                return true;
            return false;
        }) : undefined;
        return (React.createElement("div", null, props.children && React.Children.map(filtered, function (c, i) {
            var selected = i === active;
            var tmp = c;
            if (tmp.type.name === "RadioButton")
                return React.cloneElement(c, { onClick: function () { return _this.setActive(i); }, selected: selected, ingroup: true });
            else
                return c;
        })));
    };
    return RadioGroup;
}(React.Component));
export { RadioGroup };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=RadioButton.js.map